// extracted by mini-css-extract-plugin
export default {"root":"AddTimeFloatBtn_root__UY6Do","appearance":"AddTimeFloatBtn_appearance__rm1GS"};